import React from "react";
import {
  Box,
  Typography,
  Badge,
  useMediaQuery,
  useTheme,
  Modal,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DownloadIcon from "@mui/icons-material/DownloadForOffline";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GroupIcon from "@mui/icons-material/Group";

import { useAppStore } from "../../appStore";
import Withdraw from "../Wallet/withdrawRequest/withdarwDialog";

const FloatingCard = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const {
    referralUserCount,
    setAddPointOpen,
    setWithdrawOpen,
    WithdrawOpen,
  } = useAppStore();

  if (!isMobile) return null;

  const iconColor = "#ff6f00"; // Dark Orange

  const items = [
    {
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 24, color: iconColor }} />,
      title: "Add Points",
      onClick: () => setAddPointOpen(true),
    },
    {
      icon: <DownloadIcon sx={{ fontSize: 24, color: iconColor }} />,
      title: "Withdraw",
      onClick: () => setWithdrawOpen(true),
    },
    {
      icon: <AccountBalanceIcon sx={{ fontSize: 24, color: iconColor }} />,
      title: "Bank",
      onClick: () => navigate("/profile?tab=1"),
    },
    {
      icon: <GroupIcon sx={{ fontSize: 24, color: iconColor }} />,
      title: "Referrals",
      badge: referralUserCount,
      // onClick: () => navigate("/referrals"),
    },
  ];

  return (
    <>
      <Paper
        elevation={6}
        sx={{
          position: "fixed",
          bottom: 2,
          left: 10,
          right: 10,
          zIndex: 1300,
          borderRadius: 4,
          px: 1,
          py: 1.2,
          background: "linear-gradient(to top, rgba(30,36,102,0.95), rgb(30, 36, 102))",
          backdropFilter: "blur(14px)",
          boxShadow: "0 6px 20px rgba(0, 0, 0, 0.35)",
          border: "1px solid rgba(255,255,255,0.12)",
          display: { xs: "flex", sm: "none" },
          justifyContent: "space-between",
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            onClick={item.onClick}
            sx={{
              cursor: "pointer",
              textAlign: "center",
              borderRadius: 2,
              px: 1.2,
              py: 0.8,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              transition: "0.25s ease-in-out",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.08)",
              },
            }}
          >
            <Box>
              {item.badge ? (
                <Badge badgeContent={item.badge} color="secondary">
                  {item.icon}
                </Badge>
              ) : (
                item.icon
              )}
            </Box>
            <Typography
              variant="caption"
              sx={{
                color: "#fff",
                fontSize: "0.7rem",
                mt: 0.5,
                letterSpacing: 0.5,
              }}
            >
              {item.title}
            </Typography>
          </Box>
        ))}
      </Paper>

      {/* Withdraw Dialog */}
      <Modal
        open={WithdrawOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 360,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Withdraw />
        </Box>
      </Modal>
    </>
  );
};

export default FloatingCard;
